import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFound from './views/NotFound.vue'
import LegalNotes from './views/LegalNotes.vue'
import Partners from './views/Partners.vue'

Vue.use(Router)
const base = process.env.BASE_URL;

const router = new Router({
  mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return window.scrollTo({ 
        top: document.querySelector(to.hash).offsetTop - document.getElementById('navbar').offsetHeight, 
        behavior: 'smooth'
      })
    } else {
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
  routes: [
    {
      path: base,
      name: 'home',
      component: Home,
      meta: {
        title: `KLIX: Spécialistes en transition numérique (une division de La Cartoucherie)`
      },
    },
    {
      path: base + 'partners/:partner',
      name: 'partners',
      component: Partners,
      meta: {
        title: `KLIX: Spécialistes en transition numérique (une division de La Cartoucherie)`
      },
    },
    {
      path: base + 'legal-notes',
      name: 'legal-notes',
      component: LegalNotes,
      meta: {
        title: `KLIX: Blogue de la transition numérique (une division de La Cartoucherie)`
      }
    },
    {
      path: base + 'terms-of-use',
      name: 'terms-of-use',
      beforeEnter: (to, from, next) => {
        location.replace("https://www.lacartoucherie.com/modalites-utilisation/")
      }
    },
    {
      path: base + 'privacy',
      name: 'privacy',
      beforeEnter: (to, from, next) => {
        location.replace("https://www.lacartoucherie.com/politique-de-confidentialite/")
      }
    },
    {
      path: base + 'blog',
      name: 'blog',
      beforeEnter() {
        if (process.env.NODE_ENV === "production") location.href = 'https://blogue.lacartoucherie.com/'
        else location.href = 'https://dev-blogue.lacartoucherie.com/'
      }
    },
    {
      path: base + 'blog/:title',
      beforeEnter() {
        if (process.env.NODE_ENV === "production") location.href = 'https://blogue.lacartoucherie.com/:title'
        else location.href = 'https://dev-blogue.lacartoucherie.com/:title'
      }
    },
    {
      path: "*",
      name: "notFound",
      component: NotFound,
      meta: {
        title: `KLIX: Spécialistes en transition numérique (une division de La Cartoucherie)`
      },
    },
  ]
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if(!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router